import React, { useContext } from 'react';
import DeviceSelector from '../components/common/DeviceSelector';
import { FacilityUnitContext } from '../context';
import { DashboardNavigationSW25 } from '../components/dashboardsNavigations';
import MainPageLayout from '../components/common/MainPageLayout';

const UnitContainerPage = () => {
  // Contexts to manage selected facility, unit and organization.
  const { selectedUnit } = useContext(FacilityUnitContext);

  // Adding this validation since identifier changed with changes on the backend
  const showDashboard = selectedUnit?.data_unit_name;

  return (
    <MainPageLayout>
      <div className="w-full max-w-[1440px] mx-auto h-full flex flex-col">
        <div className="w-full max-w-[1440px] bg-custom-light-gray z-10">
          <h1 className="text-center text-2xl sm:text-3xl font-semibold">
            {selectedUnit?.data_unit_name ? selectedUnit.data_unit_name : ''}
          </h1>
        </div>
        <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 sm:space-y-0 justify-center items-center w-full space-y-2 mt-[20px]">
          <DeviceSelector showLabel />
        </div>

        {showDashboard && <DashboardNavigationSW25 selectedUnit={selectedUnit} />}
      </div>
    </MainPageLayout>
  );
};

export default UnitContainerPage;
